


import { AppUtilityService } from './app-utility.service';
import { CommonOpsDataModel } from '../model/commonops.model';
import { ConfigService } from './config.service';

import { Injectable } from '@angular/core';
import { LmsLoggerService } from './lms-logger.service';
import { MessageDetails } from '../model/message-details.model';
import { MessageHandlerService } from './message-handler.service';
import { Router } from '@angular/router';
import { StaticDataStoreService } from './static-datastore.service';
import { HttpClient } from '@angular/common/http';

/**
 * @export
 * @class CommonPickListService
 */
@Injectable()
export class CommonPickListService {

    private COMMON_PICKLIST_RESOURCE_URL = '/commonops/picklist';

    commonOpsDataModel: CommonOpsDataModel;
    configData: any;

    /**
     * Creates an instance of CommonPickListService.
     * @param {HttpClient} http
     * @param {ConfigService} configService
     * @param {StaticDataStoreService} staticDataStoreService
     * @param {LmsLoggerService} lmsLoggerService
     * @param {MessageHandlerService} messageHandlerService
     * @param {Router} router
     *
     * @memberOf CommonPickListService
     */
    constructor(private http: HttpClient,
        private configService: ConfigService,
        private staticDataStoreService: StaticDataStoreService,
        private lmsLoggerService: LmsLoggerService,
        private messageHandlerService: MessageHandlerService,
        private appUtilityService: AppUtilityService,
        private router: Router) {
        this.configData = this.configService.getConfigData();
    }

    /**
     * Handle error when service failed.
     * @param {any} error
     * @memberOf CommonPickListService
     */
    handleError(error) {
        this.messageHandlerService.handleMessage(<MessageDetails>({
            type: this.configService.getConfigData().message.type.server,
            level: this.configService.getConfigData().message.level.error,
            target: this.configService.getConfigData().message.target.page,
            message: this.appUtilityService.getHttpErroMessage(error, false)
        }));
    }

    /**
     * Set response in staticDataStoreService.
     * @param {any} response
     * @memberOf CommonPickListService
     */
    load(response) {
        if (response) {
            this.commonOpsDataModel = <CommonOpsDataModel>(this.staticDataStoreService.getValue('commonopsPicklist'));
            if (!this.commonOpsDataModel) { this.commonOpsDataModel = {}; }

            this.commonOpsDataModel.masterData = response;

            this.staticDataStoreService.putValue('commonopsPicklist', this.commonOpsDataModel);
            this.lmsLoggerService.logInfo('CommonopsPicklistService => load()',
                `Common Picklist Data Fetch Successfull for ${JSON.stringify(this.commonOpsDataModel)}`);
        }
    }

    /**
     * Service call for both common picklist and user profile service.
     * @returns
     * @memberOf CommonPickListService
     */
    getData() {
        const opr = 'INQL';
        // return this.http.get('data/commonOps_picklist.json')
        return this.http.get(`${this.configService.getConfigData().urls.API_URL}${this.COMMON_PICKLIST_RESOURCE_URL}?opr=${opr}`);
    }
}
